import InviteMembersSetupDetails from "./InviteMembersSetupDetails";

export default InviteMembersSetupDetails;